export class MoovStepDefinitionDTO{

    public id!: number;
    public name!: string;
    public description!: string;
    public stepType!: string;
    public parameters!: string;
    public allowedPredecessors!: string;
    public skipAllowed!: boolean;
    public approvalRequired!: boolean;
    public scopeRestrictions!: string;
    public premierPartnerRestriction!: number;
    public canUndo!: boolean;
}